import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import FeaturedProductsTable from './Table';
import AdminPageHead from '../../Common/PageHead';
import { showModal, hideModal } from 'appSrc/redux/actions';
import style from './styles/style.module.css';

class FeaturedProductsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            products: [],
            productQueryObject: {
                limit: 'none',
                featured: true,
                sort: 'featured',
            },
        };
    }
    componentDidMount() {
        this.loadProducts();
    }
    loadProducts = () => {
        return this.props.getProducts( this.state.productQueryObject )
        .then( ( products ) => {
            this.setState( ( altState ) => {
                altState.fetching= false,
                altState.products = altState.products.concat( products ),
                altState.productQueryObject.page++;
                return altState;
            } );
            return products;
        } );
    }
    productUpdated = ( index, product ) => {
        this.setState( ( altState ) => {
            if( product.featured == null ) {
                altState.products = altState.products.slice( 0, index ).concat( altState.products.slice( index + 1 ) );
            } else {
                altState.products[ index ] = product;
                altState.products = altState.products.slice( 0 );
            }
            return altState;
        } );
    }
    onManualSort = ( o, s, data ) => {
        this.setState( ( altState ) => {
            var movedProduct = altState.products.splice( data.oldIndex, 1 )[ 0 ];
            altState.products.splice( data.newIndex, 0, movedProduct );
            altState.products = altState.products.slice( 0 );
            var orderedProductIds = altState.products.map( product => product.desireid );
            this.props.updateFeaturedProductOrder( orderedProductIds );
            return altState;
        } );
    }

    
    render() {
        const { fetching, products } = this.state;

        return (
            <section className={ style.page }>
                <AdminPageHead title='Products'
                tabs={ [
                    { label: 'View All', to: '/admin/products' },
                    { label: 'Featured Products', to: '/admin/products/featured' },
                ] } />
                <div className={ style.body }>
                    <section className={ style.featuredProducts }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <FeaturedProductsTable products={ products }
                            onProductUpdated={ this.productUpdated }
                            onSort={ this.onManualSort } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getProducts: ( queryObject ) => {
            return dAPI.get( '/admin/desires', queryObject );

        },
        updateFeaturedProductOrder: ( newOrder ) => {
            return dAPI.patch( '/admin/desires/orderFeatured', { orderedDesireIds: newOrder } );

        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedProductsView );
